import { createSelector } from '@ngrx/store';
import { historyOrdersState } from '../root';

export const isLoadingMoreHistoryOrder = createSelector(historyOrdersState, (historyOrders) =>
    historyOrders.isDownloadingMore ? true : historyOrders.orders?.some((obj) => obj.isDownloading),
);
